// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10Mni","col":"styles_col__2Q5xA"};